import React from 'react';

import * as LoginActions from './actions';
import * as LoginConstants from './constants';
import * as D from './deps';
import Watchers from './sagas/watchers';
import * as ListenerSelectors from './selectors';

export default D.createDomainModule({
  name: 'listener',
  components: {
    ForgotPassword: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_forgot-password" */ './auth/components/ForgotPassword/ForgotPassword',
            )
          }
        />
      );
    },
    Login: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_login" */ './auth/components/Login/Login')
          }
        />
      );
    },
    CommunityRedirect: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_community-redirect" */ './auth/components/CommunityRedirect/CommunityRedirect',
            )
          }
        />
      );
    },
    RegisterNotAvailable: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_register-not-available" */ './auth/components/RegisterNotAvailable/RegisterNotAvailable',
            )
          }
        />
      );
    },
    Register: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_register" */ './auth/components/Register/Register',
            )
          }
        />
      );
    },
    ResetPassword: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_reset-password" */ './auth/components/ResetPassword/ResetPassword',
            )
          }
        />
      );
    },
    UserProfile: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_user-profile-new" */ './userProfile/components/UserProfile',
            )
          }
        />
      );
    },
  },
  constants: LoginConstants,
  utils: null,
  actions: LoginActions,
  reducer: {},
  selectors: ListenerSelectors,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
